import React from 'react';
import Button from 'react-bootstrap/Button';
import Collapse from 'react-bootstrap/Collapse';
import DownArrow from '../../svgs/downarrow.svg';
import { Section } from '../../models/globals';

interface ExpandableHtmlProps extends Section {
    // Whenever `controlledExpanded` changes (and is not undefined),
    // it will reset the state to that value (naming is hard)
    controlledExpanded?: boolean;
}

const ExpandableHtml: React.FC<ExpandableHtmlProps> = ({ content, controlledExpanded, header }) => {
    const [removePaddingLeft] = React.useState(() => {
        const startsWithListElement = /^\s*<(ul|ol)/;
        return startsWithListElement.test(content);
    });
    const [expanded, setExpanded] = React.useState(false);

    React.useEffect(() => {
        if (controlledExpanded !== undefined) {
            setExpanded(controlledExpanded);
        }
    }, [controlledExpanded]);

    return (
        <>
            <Button
                aria-expanded={expanded}
                className={`${
                    expanded ? '' : 'collapsed'
                } d-flex font-weight-bold px-0 text-decoration-none text-primary`.trim()}
                onClick={() => setExpanded((e) => !e)}
                variant="link"
            >
                <DownArrow className="collapse-flip size-1 text-muted mt-1" />
                <div className="pl-2 text-left" dangerouslySetInnerHTML={{ __html: header }} />
            </Button>

            <Collapse in={expanded}>
                <div className={removePaddingLeft ? '' : 'ml-1 pl-4'} dangerouslySetInnerHTML={{ __html: content }} />
            </Collapse>
        </>
    );
};

export { ExpandableHtml, ExpandableHtmlProps };
